import { Breadcrumb, Button, Card, Flex, Space } from "antd";
import { MainLayout } from "components/layouts";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";
import { ReactComponent as FilterIcon } from "../../../assets/icon/filterIcon.svg";
import TableAntd from "components/elements/Table";
import AdminCreatePaymentHistoryModal from "./AdminCreatePaymentHistoryModal";

const AdminPaymentHistory = ({
    isModalOpen = false,
    setIsModalOpen = () => { }
}) => {
    const { t } = useTranslation();
    const [useFilter, setUseFilter] = useState(false);

    const columns = [
        {
            title: <div className="text-table">{t("response_company.label.payment_date")}</div>,
            dataIndex: "paymentDate",
            key: "paymentDate",
            width: 150
        },
        {
            title: <div className="text-table">{t("response_company.label.package_detail")}</div>,
            dataIndex: "packageDetail",
            key: "packageDetail"
        },
        {
            title: <div className="text-table">{t("response_company.label.package_type")}</div>,
            dataIndex: "packageType",
            key: "packageType"
        },
        {
            title: <div className="text-table">{t("response_company.label.price_paid")}</div>,
            dataIndex: "pricePaid",
            key: "pricePaid"
        },
        {
            title: <div className="text-table" style={{ textAlign: "center" }}>{t("employee.salary.label.payment_methods")}</div>,
            dataIndex: "paymentMethod",
            key: "paymentMethod"
        }
    ];

    return (
        <MainLayout>
            <AdminCreatePaymentHistoryModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
            <Space size={24} direction="vertical" style={{ width: "100%" }}>
                <Flex vertical>
                    <Breadcrumb items={[
                        { title: t("configuration.header"), href: "/admin/response_company" },
                        { title: t("response_company.header"), href: "/admin/response_company" },
                        { title: t("response_company.label.payment_history") },
                    ]} />
                    <h2>{t("response_company.label.payment_history")}</h2>
                    <span style={{ color: "#667085" }}>{t("response_company.label.payment_history_details")}</span>
                </Flex>

                <Flex gap={8} justify="end">
                    <Button
                        type="default"
                        onClick={() => setUseFilter(!useFilter)}
                        style={{ padding: "8px 16px", height: "40px", borderRadius: "8px" }}
                    >
                        <Flex align="center" justify="center" gap={8}>
                            <FilterIcon />
                            <span style={{ color: "#667085" }}>{t('common.filter')}</span>
                        </Flex>
                    </Button>

                    <Button
                        type="primary"
                        style={{ height: "40px", borderRadius: "8px", display: "flex", alignItems: "center", backgroundColor: "var(--button-color)" }}
                        icon={<CreateIcon style={{ fontSize: 16 }} />}
                        onClick={() => { setIsModalOpen(true) }}
                    >
                        {t("response_company.label.add_payment_history")}
                    </Button>
                </Flex>

                {/* {useFilter &&
                    <Card style={{ border: "solid 1px #EAECF0" }}>
                    </Card>
                } */}

                <TableAntd
                    columns={columns}
                />
            </Space>
        </MainLayout>
    )
}

export default AdminPaymentHistory;